<template>
    <div :class="`shadow-md flex-shrink-0 ${wrapperClasses} p-1.5 pill-icon transition-all duration-300 inline-block`">
        <component :is="icon" class="w-6 h-6" />
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    icon: {
        type: Object,
        required: true
    },
    variant: {
        type: String,
        default: 'primary',
        validator: (value) => ['primary', 'secondary', 'accent', 'gradient'].includes(value)
    },
    filled: {
        type: Boolean,
        default: false
    }
})

const wrapperClasses = computed(() => {

    if (props.filled) {
        switch (props.variant) {
            case 'gradient':
                return 'bg-linear-to-tr from-accent-500 to-primary-500 border-primary-500 text-white'
            case 'accent':
                return 'border border-accent-500 bg-accent-500 text-white'
            case 'secondary':
                return 'border border-secondary-500 bg-secondary-500 text-white'
            case 'primary':
            default:
                return 'border border-primary-500 bg-primary-500 text-white'

        }
    }

    switch (props.variant) {
        case 'gradient':
            return 'bg-linear-to-tr from-accent-500 to-primary-500 border-primary-500 text-white'
        case 'accent':
            return 'border border-accent-500 text-accent-500'
        case 'secondary':
            return 'border border-secondary-500 text-secondary-500'
        case 'primary':
        default:
            return 'border border-primary-500 text-primary-500'

    }
})
</script>